import axios from 'axios';

// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json',
        },
        data:JSON.stringify(params),
        traditional: true

    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
          JWTHeaderName: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true
    }).then(res => res.data);
};

const exportFile= (method,url,params) => {
  return axios({
    method: method,
    url: url,

    data: params,
     responseType: 'blob'
  }).then(res => res.data);
};





// 图片通用公用方法
const picreq = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Accept':'application/json',
       JWTHeaderName: localStorage.getItem('logintoken')

    },
    data: params,
    traditional: true,
    transformRequest: [
      function(data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  }).then(res => res.data);
};

export {
    loginreq,
  exportFile,
    req
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js